import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
	MatLegacySnackBarRef as MatSnackBarRef,
} from "@angular/material/legacy-snack-bar";
import { SnackBarComponentBase, SnackBarOptions } from "@obg/mat.ui.core";
import { ButtonContent } from "@obg/ngx.core.content";
import { fromMillisecondsToSeconds } from "@obg/ngx.global";
import { PlatformService } from "@obg/ngx.global.evo";
import { timer } from "rxjs";
import { map, take } from "rxjs/operators";

@Component({
	selector: "obg-m-reality-check-snackbar",
	templateUrl: "./reality-check-snack-bar.component.html",
	styleUrls: ["./reality-check-snack-bar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class RealityCheckSnackBarComponent implements SnackBarComponentBase {
	@HostBinding("class.obg-m-reality-check-snackbar") cssHostClass = true;

	counters$ = new Map();

	constructor(
		@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarOptions,
		public snackBar: MatSnackBarRef<any>,
		private platformService: PlatformService
	) {}

	onDismiss() {
		this.snackBar.dismissWithAction();
	}

	getButtonCounter$(button: ButtonContent) {
		if (button.delayMs && !this.counters$.has(button)) {
			const startWith = fromMillisecondsToSeconds(button.delayMs);

			this.counters$.set(
				button,
				this.platformService.forClient(() =>
					timer(0, 1000).pipe(
						map((seconds) => startWith - seconds),
						take(startWith + 1)
					)
				)
			);
		}
		return this.counters$.get(button);
	}
}
